module.exports = __webpack_public_path__ + "static/media/fb.32870bfc.svg";